import React, { Component } from 'react'
import { Swap, SwapItem } from '../Swap'
import { closeLoader, openLoader } from '@actions/loader.js'

import Billet from '@components/Billet'
import CreditCard from '../CreditCard'
import { Modal, Stack } from 'react-bootstrap'
import { Navigate } from 'react-router-dom'
import Panel from './Panel'
import _ from 'lodash'
import { connect } from 'react-redux'
import { getOrders } from '@actions/order.js'
import { listVariables } from '@services/sm-api'
import moment from 'moment'
import { agreeDelivery } from '../../actions/checkout'
import Pix from '../Pix/index.jsx'
import { DuplicatedOrderModal } from '../../shared/DuplicatedOrderModal'
import TransferList from '../TransferList/index.js'
import { getProductsGroup } from '../../services/sm-api.js'
import TwoCreditCards from '../CreditCard/TwoCreditCards.js'
import { TransferListProvider } from '../../hooks/useTransferList/index.js'
import { filterActiveProducts } from '@actions/checkout'
import { getDeliveryIntroText, getDeliveryCards, getDeliveryEstimateCard } from '../../shared/deliveryModal'

const DIDACT_ID = 1
const EDUCA_ID = 2
const LITERARY_ID = 3
const SERVICE_ID = 7
const DIGITAL_ID = 8
const BILINGUE_ID = 9
const RELIGION_ID = 13

const PAYMENT_BILLET = 'boleto'
export const PAYMENT_PIX = 'pix'

const AcceptEstimate = props => {
  const message =
    props.message ||
    (props.isB2C
      ? 'Estou ciente da estimativa de entrega.'
      : 'Estou ciente da estimativa e concordo que a entrega seja realizada na escola.')
  return (
    <label className="checkbox_area">
      <input type="checkbox" className="checkbox" {...props} autoComplete="off" />
      <span className="checkbox__label">{message}</span>
    </label>
  )
}

class Payment extends Component {
  constructor(props) {
    super(props)
    
    this.setProductsToCreditCard = this.setProductsToCreditCard.bind(this);

    // Pedido que já existia no state ao entrar na tela: serve para diferenciar uma
    // compra concluída agora de um pedido antigo da mesma sessão.
    this.orderIdOnMount = this.props.order ? this.props.order.order_id : null

    this.state = {
      active: '',
      acceptRulesPayTwoCreditCard: false,
      opacity: true,
      alertModalOpen: false,
      modalBilletUnavailable: false,
      modalDeliveryNotice: false,
      purchasedOrder: null,
      hasBillet: this.props.paymentOptions?.has_billet,
      hasCard: this.props.paymentOptions.has_credit_card,
      hasTwoCards: (() => {
        if (
          this.props.paymentOptions.has_two_credit_cards &&
          // this.props.checkout.length === 1 &&
          this.props.checkout[0]?.products.some(p => p.business_line_id === EDUCA_ID)
        ) {
          return 1;
        }
        return 0;
      })(),
      hasCutDates: false,
      voucherBusinessLines: [],
      packEducamosBusinessLines: [],
      estimateAccepts: [],
      acceptedEstimate: false,
      acceptDeliveryTerms: false,
      isSpecialBilletCutDateEnabled: false,
      isSpecialCardCutDateEnabled: false,
      showPaymentMethod: false,
      addressModalClose: false,
      educa_delivery_type: null,
      hybridBilletActivation: null,
      isPixEnabled: false,
    }
    this._isMounted = false
  }

  _setActive = panel => {
    this.setState({ active: panel, acceptDeliveryTerms: false, acceptedEstimate: false })
    this.setDeliveryType(panel)
  }

  _setModalState(modalState) {
    this.setState({ alertModalOpen: modalState })
  }

  hasCutDate() {
    const voucher = _.last(this.props.checkout)
    if (!voucher) return false
    const lastCutDate = _.last(voucher.contract_cut_dates)
    return moment().isBefore(moment(lastCutDate))
  }

  setDeliveryType() {
    const voucher = _.last(this.props.checkout)

    const _deliveryType = () => {
      let ensino = voucher.serie_id.substring(1).toLowerCase()
      switch (ensino) {
        case 'em':
          return voucher.ensino_em
        case 'f1':
          return voucher.ensino_ef1
        case 'f2':
          return voucher.ensino_ef2
        case 'ei':
          return voucher.ensino_ei
        case 'maternal':
          return voucher.ensino_ei
        default:
          return null
      }
    }

    this.setState({
      modalDeliveryNotice: _.isEmpty(this.state.voucherBusinessLines) ? false : true,
      educa_delivery_type: _deliveryType(),
      estimateAccepts: [],
      acceptedEstimate: false,
    })
  }

  _showDownloadBilletButton() {
    const voucherBusinessLines = this.state.voucherBusinessLines
    const estimateAccepts = _.sortedUniq(this.state.estimateAccepts)
    return _.difference(voucherBusinessLines, estimateAccepts).length === 0 || !this.state.hasCutDates
  }

  _showBusinessLinesMessage(business_line_id) {
    return _.indexOf(this.state.voucherBusinessLines, business_line_id) !== -1
  }

  _businessLineHasPackEducamos(business_line_id) {
    return this.state.packEducamosBusinessLines.includes(business_line_id)
  }

  _showPaymentWithBillet() {
    const voucher = _.last(this.props.checkout)
    const endDateArray = voucher.contract_end.split('/')
    const endDate = `${endDateArray[2]}-${endDateArray[1]}-${endDateArray[0]}`
    const cutDates = voucher.contract_cut_dates

    const year = new Date().getFullYear()
    const january = moment(`${year}-01-01`).format('YYYY-MM-DD')
    const march = moment(`${year}-03-16`).format('YYYY-MM-DD')

    if (moment().isBetween(january, march)) {
      for (let cutDate of cutDates) {
        let sub4days = moment(cutDate).subtract(4, 'days').format('YYYY-MM-DD')
        if (moment().isBetween(sub4days, cutDate) || moment().isSame(cutDate, 'day')) {
          this.setState({
            hasBillet: false,
            modalBilletUnavailable: true,
          })
          return
        }
      }
    }

    let sub4days = moment(endDate).subtract(4, 'days').format('YYYY-MM-DD')

    if (moment().isSame(endDate, 'day') || moment().isBetween(sub4days, endDate)) {
      this.setState({
        hasBillet: false,
        modalBilletUnavailable: true,
      })
    }
  }

  _educaDeliveryType() {
    switch (`${this.state.educa_delivery_type}`) {
      case '2':
        return 'bimestralmente'
      case '3':
        return 'trimestralmente'
      case '5':
        return 'semestralmente'
      case '6':
        return 'anualmente'
      case '7':
        return 'imediata'
      default:
        return 'bimestralmente/semestralmente'
    }
  }

  componentDidUpdate() {
    // Checkout vazio sem compra concluída (ex.: o usuário removeu todos os alunos):
    // não há o que pagar, volta para a home. Precisa ser no didUpdate porque no
    // componentWillUpdate `this.props` ainda são os anteriores ao esvaziamento.
    if (_.isEmpty(this.props.checkout) && window.location.pathname.includes('pagamento') && !this.orderCompleted) {
      window.location.href = '/'
    }
  }

  async componentDidMount() {

    let count = 0
    this._isMounted = true
    this.props.openLoader()
    await this.props.getOrders(this.props.userData.user.id)
    this.alreadyPurchase()
    this._showPaymentWithBillet()
    this.props.checkout.map(voucher => {
      voucher.products.map(product => {
        if (product.business_line_id !== SERVICE_ID && product.business_line_id !== DIGITAL_ID && product.active) {
          this.state.voucherBusinessLines.push(product.business_line_id)
        } else {
          count++
        }

        if (Boolean(product.pack_educamos)) {
          this.state.packEducamosBusinessLines.push(product.business_line_id)
        }

        return product
      })
      return voucher
    })

    if (_.isEmpty(this.state.voucherBusinessLines) && count > 0) {
      this.setState({ showPaymentMethod: true })
    }

    listVariables().then(data => {
      const isSpecialBilletCutDateEnabled = _.get(_.find(data, { key: 'SPECIAL_BILLET_CUT_DATE' }), 'value', false)
      const isSpecialCardCutDateEnabled = _.get(_.find(data, { key: 'SPECIAL_CARD_CUT_DATE' }), 'value', false)

      const hybridBilletActivation = _.find(data, { key: 'HYBRID_BILLET_ACTIVATION' })
      const isPixEnabled = _.find(data, { key: 'PIX_ITAU_ACTIVATION' }).value === '1'

      this.setState({
        isSpecialBilletCutDateEnabled: Boolean(Number(isSpecialBilletCutDateEnabled)),
        isSpecialCardCutDateEnabled: Boolean(Number(isSpecialCardCutDateEnabled)),
        hybridBilletActivation: hybridBilletActivation.value,
        isPixEnabled,
      })
      this.props.closeLoader()
    })

  }

  componentWillUnmount() {
    this._isMounted = false
  }

  alreadyPurchase() {
    const voucher_id = this.props.activeVoucher.toUpperCase()
    const orders = _.first(
      this.props.orders.filter(order => {
        if (['PG', 'AP', 'BAP', 'PAV'].includes(order.status)) {
          const vouchers = _.values(order.vouchers).map(voucher => {
            return _.keys(voucher)[0].toUpperCase()
          })
          return vouchers.includes(voucher_id)
        }
        return false
      }),
    )
    if (this._isMounted && orders) {
      this.setState({ purchasedOrder: orders.order_id })
      this._setModalState(true)
    }
  }

  async groupProducts() {
    if (this.state.active === 'two-credit-cards') {
      const products = await getProductsGroup(this.props.checkout[0].products);
      this.setState({ active: 'transfer-list', groupProducts: products })
    }
  }

  setProductsToCreditCard(distributedProducts) {
    this.setState({ active: 'two-credit-cards-payment', distributedProductsToCreditCard: distributedProducts })
  }

  get orderCompleted() {
    const orderId = this.props.order ? this.props.order.order_id : null
    return !!orderId && orderId !== this.orderIdOnMount
  }

  get deliveryEstimate() {
    const voucher = _.last(this.props.checkout)
    if (!voucher) return null
    const nextCutDate = voucher.contract_cut_dates.find(date => moment(date).isAfter(moment()))
    const deliveryDate = moment(nextCutDate).add(20, 'days')
    return deliveryDate.format('DD/MM/YYYY')
  }

  render() {
    
    let { checkout } = this.props

    // A compra esvazia o checkout antes da navegação, então este render ainda roda uma
    // vez sem nenhum voucher: sem a guarda abaixo ele quebra em `first.immediate_delivery`.
    if (_.isEmpty(checkout)) {
      return this.orderCompleted ? <Navigate to="/steps/concluido" replace /> : null
    }

    const first = _.first(checkout)
    const immediate_delivery = '7'

    const is_immediate = this.state.educa_delivery_type == immediate_delivery || first?.immediate_delivery == 1
    const school_is_b2c = !!first ? Boolean(first.school_is_b2c) : false
    const cutDateActive = this.hasCutDate()
    const deliveryEstimateValue = this.deliveryEstimate
    const isSingleBook = this.state.voucherBusinessLines.length === 1

    return (
      <React.Fragment>
        <DuplicatedOrderModal
          show={this.state.alertModalOpen}
          purchasedOrder={this.state.purchasedOrder}
          onClose={() => {
            this._setModalState(false)
          }}
        />

        <Modal show={this.state.modalBilletUnavailable}>
          <Modal.Body>
            <div className="modalHeader">
              <span className="icon-alert" />
              <h1>Atenção</h1>
            </div>

            <div className="modalContent">
              <p>
                O lote para envio será encerrado dentro de alguns dias, e como o pagamento via boleto poderá demorar até
                3 dias para ser compensado, esta modalidade está automaticamente inativada. O pagamento poderá ser feito
                via cartão de crédito.
              </p>
              <p>Em caso de dúvidas acesse o menu "Ajuda".</p>
            </div>

            <div className="modalFooter">
              <button
                className="modal-close"
                onClick={() => {
                  this.setState({ modalBilletUnavailable: false })
                }}
              >
                Fechar
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={this.state.modalDeliveryNotice} dialogClassName="delivery-alert-modal">
          <Modal.Body>
            <div className="modalHeader">
              <span className="icon-alert" />
              <h1>Alerta sobre o prazo de entrega</h1>
            </div>

            <div className="modalContent">
              {getDeliveryIntroText(is_immediate, school_is_b2c, isSingleBook)}

              <div className="delivery-cards-list">
                {getDeliveryCards(this.state.voucherBusinessLines, is_immediate, school_is_b2c, this._educaDeliveryType()).map(card => (
                  <div key={card.key} className="delivery-card">
                    <div className="delivery-card__text">
                      <strong>{card.title}</strong>
                      {card.subtitle && <span>{card.subtitle}</span>}
                    </div>
                  </div>
                ))}
              </div>

              {getDeliveryEstimateCard(is_immediate, school_is_b2c, cutDateActive, deliveryEstimateValue)}

              <AcceptEstimate
                id="payment-deadline-alert-ckeckbox"
                checked={this.state.acceptedEstimate}
                onChange={() => this.setState({ acceptedEstimate: !this.state.acceptedEstimate })}
                isB2C={school_is_b2c}
              />

              {this.state.active === PAYMENT_BILLET && (
                <p className="delivery-note">
                  <span className="text-red">* </span>O pagamento por cartão de crédito poderá ter antecipação na
                  estimativa de entrega.
                </p>
              )}
            </div>
            <div className="modalFooter">
              <button
                className="modal-close inline-button"
                onClick={() => {
                  this.setState({ modalDeliveryNotice: false })
                }}
              >
                Cancelar
              </button>
              <button
                id="payment-deadline-alert-confirm-button"
                disabled={!this.state.acceptedEstimate}
                className={`modal-close inline-button ${!this.state.acceptedEstimate ? 'disabled' : 'accept'}`}
                onClick={() => {
                  this.props.agreeDelivery()
                  this.setState({
                    modalDeliveryNotice: false,
                    acceptDeliveryTerms: true,
                  })
                }}
              >
                Entendi
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Swap active={this.state.active}>
          <SwapItem name="boleto">
            {/* @TODO: pass just the object to change the acceptDeliveryTerms property */}
            <Panel
              active={this.state.active}
              setActive={this._setActive}
              hasBillet={this.state.hasBillet}
              hasCard={this.state.hasCard}
              thisParent={this}
              hybridBilletActivation={this.state.hybridBilletActivation}
              isPixEnabled={this.state.isPixEnabled}
              hasTwoCards={this.state.hasTwoCards}
              payWithTwoCards={this.props.checkout.length === 1}
            >
              {this.state.acceptDeliveryTerms || this.state.showPaymentMethod ? (
                this.state.hybridBilletActivation == 1 ? (
                  <div className="payment-info">
                    <div className="payment-info__section">
                      <span className="payment-info__title">ATENÇÃO</span>
                      <p className="payment-info__desc">
                        - O boleto possui validade de 1 (um) dia corrido. Após o vencimento o pedido será cancelado.
                      </p>
                      <p className="payment-info__desc">- Pagamento por boleto apenas à vista.</p>
                    </div>
                    <div className="payment-info__section">
                      <h4>
                        <b>
                          Pagamento do boleto via PIX <sup>novo</sup>
                        </b>
                      </h4>
                      <p className="payment-info__desc">- Você poderá realizar o pagamento deste boleto via PIX.</p>
                      <p className="payment-info__desc">
                        - Após o pagamento, a confirmação será realizada em alguns minutos.
                      </p>
                      <p className="payment-info__desc">
                        - Você poderá acompanhar a confirmação do pagamento na tela de Resumo do pedido.
                      </p>
                      <p className="payment-info__desc">
                        - Um e-mail de confirmação de pagamento também será enviado assim que o pagamento for confirmado
                        (verifique suas caixas de SPAM e lixo eletrônico).
                      </p>
                    </div>
                    <div className="payment-info__section">
                      <h4>
                        <b>Pagamento do boleto via código de barras (modo convencional)</b>
                      </h4>
                      <p className="payment-info__desc">
                        - Seu pedido poderá demorar até 3 (três) dias úteis para ser processado após o pagamento,{' '}
                        <b>podendo alterar a estimativa de entrega.</b>
                      </p>
                      <p className="payment-info__desc">
                        - Necessário desativar o bloqueador de pop-up de seu navegador antes de gerar o boleto.
                      </p>
                      <p className="payment-info__desc">
                        - O boleto deverá ser pago em qualquer agência bancária ou pelo internet banking.
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="payment-info">
                    <span className="payment-info__title">ATENÇÃO</span>
                    <p className="payment-info__desc">
                      - Seu pedido poderá demorar até 3 (três) dias úteis para ser processado após o pagamento,
                      <b> podendo alterar a estimativa de entrega</b>.
                    </p>
                    <p className="payment-info__desc">
                      - Necessário desativar o bloqueador de pop-up de seu navegador antes de gerar o boleto.
                    </p>
                    <p className="payment-info__desc">
                      - O boleto deverá ser pago em qualquer agência bancária ou pelo <i>internet banking</i>.
                    </p>
                    <p className="payment-info__desc">
                      - O boleto possui validade de 1 (um) dia corrido. Após o vencimento o pedido será cancelado.
                    </p>
                    <p className="payment-info__desc">- Pagamento por boleto apenas à vista.</p>
                  </div>
                )
              ) : null}

              {(this.state.acceptDeliveryTerms || this.state.showPaymentMethod) && this._showDownloadBilletButton() && (
                <Billet hybridBilletActivation={this.state.hybridBilletActivation} />
              )}
            </Panel>
          </SwapItem>

          <SwapItem name="card">
            {/* @TODO: pass just the object to change the acceptDeliveryTerms property */}
            <Panel
              active={this.state.active}
              setActive={panel => this._setActive(panel)}
              hasBillet={this.state.hasBillet}
              hasCard={this.state.hasCard}
              thisParent={this}
              hybridBilletActivation={this.state.hybridBilletActivation}
              isPixEnabled={this.state.isPixEnabled}
              hasTwoCards={this.state.hasTwoCards}
              payWithTwoCards={this.props.checkout.length === 1}
            >
              {(this.state.acceptDeliveryTerms || this.state.showPaymentMethod) && this._showDownloadBilletButton() && (
                <div>
                  <p>Clique em “Continuar” para ver nossas condições de parcelamento</p>
                  <button
                    id="payment-continue-button"
                    className="button__normal"
                    onClick={() => {
                      window.ga('send', {
                        hitType: 'event',
                        eventCategory: 'compra',
                        eventAction: 'click',
                        eventLabel: 'cartao_credito_5',
                      })

                      this.setState({ active: 'card-form' })
                    }}
                  >
                    Continuar
                  </button>
                </div>
              )}
            </Panel>
          </SwapItem>

          <SwapItem name={PAYMENT_PIX}>
            <Panel
              active={this.state.active}
              setActive={this._setActive}
              hasBillet={this.state.hasBillet}
              hasCard={this.state.hasCard}
              thisParent={this}
              hybridBilletActivation={this.state.hybridBilletActivation}
              isPixEnabled={this.state.isPixEnabled}
              hasTwoCards={this.state.hasTwoCards}
              payWithTwoCards={this.props.checkout.length === 1}
            >
              {this.state.acceptDeliveryTerms && (
                <div className="payment-info">
                  <span className="payment-info__title">ATENÇÃO</span>
                  <p className="payment-info__desc">
                    - Ao selecionar o pagamento via PIX, uma chave será gerada e o pagamento deverá ser realizado no
                    aplicativo de seu banco ou via internet banking, em até 10 minutos.
                  </p>
                  <p className="payment-info__desc">
                    - Assim que o pedido for pago, a tela será atualizada e seu pedido será aprovado automaticamente.
                  </p>
                  <p className="payment-info__desc">
                    - Caso você feche seu navegador antes de realizar o pagamento, o seu pedido será cancelado e você
                    terá que realizar um novo pedido.
                  </p>
                  <p className="payment-info__desc">
                    - Caso você feche o navegador após realizar o pagamento, aguarde 5 minutos e verifique o status de
                    seu pedido em "Pedidos" no SM Direto.
                  </p>
                  <p className="payment-info__desc">
                    - Caso o pagamento não seja realizado dentro do período de 10 minutos, o pedido será automaticamente
                    cancelado. Se cancelado, a chave expirará e você precisará gerar um novo pedido.
                  </p>
                </div>
              )}

              {(this.state.acceptDeliveryTerms || this.state.showPaymentMethod) && <Pix />}
            </Panel>
          </SwapItem>

          <SwapItem name="card-form">
            <CreditCard />
          </SwapItem>

          <SwapItem name="">
            <Panel
              active={this.state.active}
              setActive={panel => this._setActive(panel)}
              hasBillet={this.state.hasBillet}
              hasCard={this.state.hasCard}
              thisParent={this}
              hybridBilletActivation={this.state.hybridBilletActivation}
              isPixEnabled={this.state.isPixEnabled}
              hasTwoCards={this.state.hasTwoCards}
              payWithTwoCards={this.props.checkout.length === 1}
            />
          </SwapItem>

          <SwapItem name="two-credit-cards">
            {/* @TODO: pass just the objec t to change the acceptDeliveryTerms property */}
            <Panel
              active={this.state.active}
              setActive={this._setActive}
              hasBillet={this.state.hasBillet}
              hasCard={this.state.hasCard}
              thisParent={this}
              hybridBilletActivation={this.state.hybridBilletActivation}
              isPixEnabled={this.state.isPixEnabled}
              hasTwoCards={this.state.hasTwoCards}
              payWithTwoCards={this.props.checkout.length === 1}
            >
              {this.state.acceptDeliveryTerms && <div className="payment-info">
                <div className="payment-info__section">
                  <span className="payment-info__title">Regras de pagamento com 2 cartões</span>
                  <p className="payment-info__desc">
                    - Para realizar o pagamento, será necessário selecionar os ítens que deverão ser pagos em cada cartão.
                  </p>
                  <p className="payment-info__desc">
                    - O pagamento será confirmado após a validação de ambos os cartões. Caso algum deles não seja confirmado, o pedido será
                    automaticamente cancelado e será feito o estorno do cartão confirmado
                  </p>
                  <p className="payment-info__desc">
                    - A logística de entrega não será afetada em função dessa forma de pagamento.
                  </p>
                  <label className="checkbox_area">

                    <input onChange={() => this.setState({ acceptRulesPayTwoCreditCard: !this.state.acceptRulesPayTwoCreditCard })} type="checkbox" className="checkbox" />
                    <span>Estou ciente das regras e desejo continuar</span>
                  </label>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <button
                    onClick={() => this.groupProducts()}
                    disabled={!this.state.acceptRulesPayTwoCreditCard}
                    className="button__medium payment__button-boleto">
                    Continuar
                  </button>
                </div>
              </div>
              }

            </Panel>
          </SwapItem>
          <SwapItem name="transfer-list">
            <TransferListProvider>
              <TransferList
                setProductsToCreditCard={this.setProductsToCreditCard}
                groupProducts={this.state?.groupProducts || []}
              />
            </TransferListProvider >
          </SwapItem>

          <SwapItem name="two-credit-cards-payment">
            <CreditCard products={this.state.distributedProductsToCreditCard} />
          </SwapItem>

        </Swap>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    orders: state.order.orders,
    activeVoucher: state.activeVoucher.voucher,
    userData: state.sessionReducer,
    paymentOptions: state.school.payment_options,
    school: state.school,
    order: state.creditCard,
    checkout: filterActiveProducts(state),
  }
}

const mapDispatchToProps = dispatch => ({
  openLoader: () => dispatch(openLoader()),
  closeLoader: () => dispatch(closeLoader()),
  getOrders: userId => dispatch(getOrders({ id: userId })),
  agreeDelivery: () => dispatch(agreeDelivery()),
})

// export default Payment
export default connect(mapStateToProps, mapDispatchToProps)(Payment)